import { render, staticRenderFns } from "./salesCreditamountList.vue?vue&type=template&id=0bd405b1"
import script from "./salesCreditamountList.vue?vue&type=script&lang=js"
export * from "./salesCreditamountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports